import React, { useState } from 'react';
import axios from './api/axiosConfig';
import CryptoJS from 'crypto-js';
import './styles/common.css';
import './App.css';

import { AUTH_API_URL, BASE_URL } from './api/config';
import { parseValidationError } from './utils/errorHandler';
const API_URL = AUTH_API_URL;

// SVG 图标组件
const Icons = {
  User: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Lock: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </svg>
  ),
  Mail: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Phone: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
  ),
  IdCard: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0m-5 8a2 2 0 100-4 2 2 0 000 4zm0 0c1.306 0 2.417.835 2.83 2M9 14a3.001 3.001 0 00-2.83 2M15 11h3m-3 4h2" />
    </svg>
  ),
  Eye: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),
  EyeOff: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
    </svg>
  ),
  Home: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
    </svg>
  ),
};

// SHA1 哈希函数（使用 crypto-js，不依赖 crypto.subtle）
const sha1 = (message) => {
  return CryptoJS.SHA1(message).toString(CryptoJS.enc.Hex);
};

function RegisterPage({ onNavigateToLogin }) {
  const [formData, setFormData] = useState({
    nickname: '',
    password: '',
    confirmPassword: '',
    realName: '',
    gender: '女',
    role: 'recruitment',
    phone: '',
    email: '',
    idCard: ''
  });

  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    // 昵称验证
    if (!formData.nickname.trim()) {
      newErrors.nickname = '请输入昵称';
    } else if (!/^[\u4e00-\u9fa5a-zA-Z0-9_]+$/.test(formData.nickname)) {
      newErrors.nickname = '昵称只能包含中文、字母、数字和下划线';
    }

    // 密码验证
    if (!formData.password) {
      newErrors.password = '请输入密码';
    } else if (formData.password.length < 8) {
      newErrors.password = '密码长度需要 8 位以上';
    } else if (!/[a-zA-Z]/.test(formData.password) || !/\d/.test(formData.password)) {
      newErrors.password = '密码需要数字和字母的组合';
    }

    // 检查密码是否为出生日期
    if (formData.idCard && formData.password) {
      const birthday = formData.idCard.substring(6, 14);
      const year = formData.idCard.substring(6, 10);
      const month = formData.idCard.substring(10, 12);
      const day = formData.idCard.substring(12, 14);

      if (formData.password.includes(birthday) ||
          formData.password.includes(year + month) ||
          formData.password.includes(year + day)) {
        newErrors.password = '密码不能为出生日期';
      }
    }

    // 确认密码
    if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = '两次输入的密码不一致';
    }

    // 真实姓名
    if (!formData.realName.trim()) {
      newErrors.realName = '请输入真实姓名';
    }

    // 手机号验证
    if (!formData.phone) {
      newErrors.phone = '请输入手机号';
    } else if (!/^1[3-9]\d{9}$/.test(formData.phone)) {
      newErrors.phone = '手机号格式不正确';
    }

    // 邮箱验证（可选）
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = '邮箱格式不正确';
    }

    // 身份证验证（必填）
    if (!formData.idCard) {
      newErrors.idCard = '请输入身份证号码';
    } else if (!/^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(formData.idCard)) {
      newErrors.idCard = '身份证号码格式不正确';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // 清除对应字段的错误
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setSubmitting(true);

    try {
      // 前端计算密码的 SHA1 哈希
      const passwordHash = sha1(formData.password);

      // 发送注册请求
      const response = await axios.post(`${API_URL}/register`, {
        nickname: formData.nickname,
        password_hash: passwordHash,
        real_name: formData.realName,
        gender: formData.gender,
        role: formData.role,
        phone: formData.phone,
        email: formData.email || null,
        id_card: formData.idCard.toUpperCase()
      });

      if (response.data.success) {
        alert('注册成功，请登录');
        onNavigateToLogin();
      }
    } catch (error) {
      console.error('Register error:', error);
      const errorMsg = parseValidationError(error);
      alert(errorMsg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-card">
        <div className="auth-header">
          <div className="auth-icon">
            <Icons.User />
          </div>
          <h1 className="auth-title">用户注册</h1>
          <p className="auth-subtitle">创建您的账户</p>
        </div>

        <div className="auth-body">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label required">
                <Icons.User /> 昵称
              </label>
              <input
                type="text"
                name="nickname"
                value={formData.nickname}
                onChange={handleChange}
                className={`form-input ${errors.nickname ? 'input-error' : ''}`}
                placeholder="请输入昵称"
              />
              {errors.nickname && <span className="error-text">{errors.nickname}</span>}
            </div>

            <div className="form-group">
              <label className="form-label required">
                <Icons.Lock /> 密码
              </label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className={`form-input ${errors.password ? 'input-error' : ''}`}
                  placeholder="8 位以上，数字和字母组合"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <Icons.EyeOff /> : <Icons.Eye />}
                </button>
              </div>
              {errors.password && <span className="error-text">{errors.password}</span>}
            </div>

            <div className="form-group">
              <label className="form-label required">确认密码</label>
              <div className="password-input-wrapper">
                <input
                  type={showConfirmPassword ? 'text' : 'password'}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  className={`form-input ${errors.confirmPassword ? 'input-error' : ''}`}
                  placeholder="请再次输入密码"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? <Icons.EyeOff /> : <Icons.Eye />}
                </button>
              </div>
              {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
            </div>

            <div className="form-group">
              <label className="form-label required">真实姓名</label>
              <input
                type="text"
                name="realName"
                value={formData.realName}
                onChange={handleChange}
                className={`form-input ${errors.realName ? 'input-error' : ''}`}
                placeholder="请输入真实姓名"
              />
              {errors.realName && <span className="error-text">{errors.realName}</span>}
            </div>

            <div className="form-group">
              <label className="form-label required">性别</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="form-select"
              >
                <option value="女">女</option>
                <option value="男">男</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label required">角色</label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="form-select"
              >
                <option value="recruitment">招生</option>
                <option value="sales">销售</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label required">
                <Icons.Phone /> 手机号
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className={`form-input ${errors.phone ? 'input-error' : ''}`}
                placeholder="请输入手机号"
                maxLength="11"
              />
              {errors.phone && <span className="error-text">{errors.phone}</span>}
            </div>

            <div className="form-group">
              <label className="form-label">
                <Icons.Mail /> 邮箱（选填）
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`form-input ${errors.email ? 'input-error' : ''}`}
                placeholder="请输入邮箱"
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label className="form-label required">
                <Icons.IdCard /> 身份证号码
              </label>
              <input
                type="text"
                name="idCard"
                value={formData.idCard}
                onChange={handleChange}
                className={`form-input ${errors.idCard ? 'input-error' : ''}`}
                placeholder="请输入身份证号码"
                maxLength="18"
              />
              {errors.idCard && <span className="error-text">{errors.idCard}</span>}
            </div>

            <button
              type="submit"
              className="btn-primary auth-btn"
              disabled={submitting}
            >
              {submitting ? '注册中...' : '立即注册'}
            </button>
          </form>
        </div>

        <div className="auth-footer">
          <span>已有账户？</span>
          <button className="auth-link" onClick={onNavigateToLogin}>
            立即登录
          </button>
          <button className="auth-link back-home" onClick={() => window.location.href = '/'}>
            <Icons.Home /> 返回首页
          </button>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
